import { PropsWithChildren } from "react"

type TableHeaderProps = {
  className?: string 
  sticky?: boolean 
  top?: string
  backgroundColor?: string
}

export const TableHeader = (params: PropsWithChildren<TableHeaderProps>) => {
  return <thead className={`${params?.backgroundColor ? params?.backgroundColor : "!bg-black"} !text-white ${params.sticky && `sticky top[${params.top && '0px'}]`} ${params.className}`}>{params.children}</thead>
}